<template>
  <div class="programme">
    <!--  可视化云屏-->
    <div class="banner">
      <img :src=cloudOne.topPhotos  width="100%" height="300px">
      <div class="wrap">
        <h1>{{ cloudOne.title }}</h1>
      </div>
    </div>
    <div class="linkbanner">
      <el-link style="font-size: 3rem" type="danger" @click="index">首页</el-link>
      <el-icon><ArrowRight /></el-icon>
      <el-link style="font-size: 3rem" type="danger"  @click="next">云仓</el-link>
      <el-icon><ArrowRight /></el-icon>
      <el-link style="font-size: 3rem" type="info">{{ cloudOne.title }}</el-link>
    </div>
    <div class="wrap">
      <div class="shopping">
          <div class="money">¥<span>{{  parseFloat(cloudOne.price).toFixed(2)}}</span></div>
        <div class="cay">
          <div v-for="(item,index) in caylist" :key="index">
            <img :src="require('../../../assets/'+item.img)">
            <span>{{item.name}}</span>
          </div>
        </div>
      </div>
      <div v-html="cloudOne.detail">

      </div>
      <el-button
          type="primary"
          size="small"
          @click="showDownloadDialog = true"
          :style="{
                        width:'12rem',
            height:'6rem',
            backgroundColor: '#F32835',  // 自定义底色（建议使用绿色系）
            borderColor: '#F32835',     // 同步修改边框色
            padding: '1rem',
            borderRadius: '1rem',
            boxShadow: '0 6px 12px rgba(243, 40, 53, 0.4)',
          }"
      >
        <el-icon :size="30" style="margin-top: 0.1rem">
          <Download/>
        </el-icon>
        <span style="font-size: 1.8rem;font-weight: 600;padding-right: 1rem;padding-left: 0">前往下载</span>
      </el-button>
    </div>

    <!-- 下载验证弹窗 -->
    <el-dialog
        title="文件下载验证"
        v-model="showDownloadDialog"
        width="30%"
        :close-on-click-modal="false"
    >
      <el-form :model="downloadForm" :rules="downloadRules" ref="downloadForm">
        <el-form-item label="下载码" prop="code" style="font-size: 1.5rem;">
          <el-input
              v-model="downloadForm.code"
              placeholder="请输入下载码"
              @keyup.enter.native="validateDownloadCode"
              style="font-size: 1.5rem;"
          ></el-input>
        </el-form-item>
      </el-form>

      <!-- 验证成功后显示下载区域 -->
      <div v-if="isCodeValid" class="download-section">
        <div class="file-info">
          <!-- 下载列表标题 -->
          <div style="font-size: 1.5rem; color: #666; margin-bottom: 10px;">可下载文件列表：</div>
          <!-- 循环渲染文件项 -->
          <div
              v-for="(fileUrl, index) in files"
              :key="index"
              style="display: flex; align-items: center; margin-bottom: 8px; padding: 8px; border: 1px solid #eee; border-radius: 4px;"
          >
            <!-- 显示文件名 -->
            <span style="flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 1.5rem;"
                  :title="getFileNameFromUrl(fileUrl)">
        {{ getFileNameFromUrl(fileUrl) }}
      </span>
            <!-- 下载按钮 -->
            <el-button
                type="primary"
                size="mini"
                @click="handleFileDownload(fileUrl)"
                style="margin-left: 10px; font-size: 2rem;"
            >
              <!-- 将icon属性改为组件形式 -->
              <el-icon :size="20">
                <Download/>
              </el-icon>
              下载
            </el-button>
          </div>
        </div>
      </div>


      <template #footer>  <!-- Element Plus 插槽语法 -->
        <span class="dialog-footer">
    <el-button @click="showDownloadDialog = false" style="font-size: 2rem;">取 消</el-button>
    <el-button type="primary" @click="validateDownloadCode" :loading="isValidating" style="font-size: 2rem;">确 定</el-button>
  </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import newService from "@/api/newService";
import {ArrowRight, Download} from '@element-plus/icons-vue';

export default {
  name: "programmeOne",
  components: {
    ArrowRight,
    // 注册图标组件
    Download
  },
    created() {
      this.getCloudOne()
    },
    data(){
    return {
      files:[],
      cloudOne:{},
      bannerimg:"Yuncang1/Yuncang1.png",
      bannerimg2:"Yuncang1/Yuncang7.png",
      bannerimg3:"Yuncang1/Yuncang8.png",
      caylist:[{
        img:'Yuncang1/Yuncang4.png',
        name:'银联支付'
      },{
        img:'Yuncang1/Yuncang5.png',
        name:'微信支付'
      },{
        img:'Yuncang1/Yuncang6.png',
        name:'支付宝支付'
      }],
      // 新增弹窗相关数据
      showDownloadDialog: false,
      downloadForm: { code: '' },
      downloadRules: {
        code: [
          { required: true, message: '请输入下载码', trigger: 'blur' },
          { min: 16, max: 16, message: '下载码长度为16位', trigger: 'blur' }
        ]
      },
      isCodeValid: false,
      isValidating: false
    }
  },
  methods: {
    index() {
      this.$store.state.components = 'home'
    },
    next() {
      this.$store.state.components = 'Yuncang'
    },
    getCloudOne() {
      const id = localStorage.getItem('cloudId');
      newService.getCloudOne(id).then((res) => {
        this.cloudOne = res
      })
    },
    // 新增下载验证方法
    validateDownloadCode() {
      this.$refs.downloadForm.validate(valid => {
        if (!valid) return;
        const id = localStorage.getItem('cloudId');
        this.isValidating = true;
        newService.getAddressByCode(this.downloadForm.code, id)
            .then((res) => {
              const resStr = String(res).trim();
              if (resStr.includes("错误^/^")) {
                const parts = resStr.split(':');
                let contentAfterColon = '';
                if (parts.length >= 2) {
                  contentAfterColon = parts.slice(1).join(':').trim();
                } else {
                  contentAfterColon = resStr;
                }
                this.$message.error(contentAfterColon)
              } else {
                this.$message.success("下载码验证通过");
                let addressArr = res.address.split(",/");
                for (let i = 0; i < addressArr.length; i++) {
                  if (i !== 0) {
                    addressArr[i] = "/" + addressArr[i];
                  }
                  addressArr[i] = addressArr[i] + "&code=" + this.downloadForm.code;
                }
                this.files = addressArr;
                this.isCodeValid = true;
              }
            })
            .catch(error => {
              console.log(error)
            })
            .finally(this.isValidating = false)
      });
    },
    getFileNameFromUrl(item) {
      console.log(item)
      return item.substring(item.lastIndexOf("&name=") + 6, item.indexOf("&code="))
    },
    handleFileDownload(fileUrl) {
      const code = fileUrl.substring(fileUrl.lastIndexOf("&code=") + 6)
      const uploadPath = fileUrl.substring(fileUrl.lastIndexOf("?uploadPath=") + 12, fileUrl.indexOf("&name="))
      const name = fileUrl.substring(fileUrl.lastIndexOf("&name=") + 6, fileUrl.indexOf("&code="))
      let url = "/api/file/byCodedownLoadToUser?uploadPath="+uploadPath+"&name="+name+"&cloudId="+localStorage.getItem('cloudId')+"&code="+code
      window.open(encodeURI(url), '_self');
    },
  }
}
</script>

<style lang="less" scoped>
.programme{
  .linkbanner{
    width: 118rem;
    height: 4.8rem;
    display: flex;
    align-items: center;
    margin: auto;
    background: #F8F8F8;
    box-shadow: 0px 1px 0px 0px #E5E5E5;
    padding-left: 2rem;
    font-size: 1.6rem;
    /deep/.el-link--inner{
      font-size: 1.6rem;
    }
    .el-link.el-link--danger{
      color: #ED0200;
      font-size: 1.6rem;
    }
    i{
      margin: 0px 5px;
      font-size: 1.6rem;
      padding-top: 1px;
    }
  }
  .banner{
    display: block;
    overflow: hidden;
    position: relative;
    width: 120rem;
    min-width: 120rem;
    margin: 6.4rem auto 0;
    img{display: block}
    .wrap{
      width: auto;
      position: absolute;
      top: 6rem;
      left:  0rem;
      z-index: 1;
      color: #fff;
      margin: 0;
      h1{
        font-size: 7.6rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        letter-spacing: .8rem;
        margin-left: 10rem;
      }
      h2{
        font-size: 2.8rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        margin-left: 10rem;
      }
    }
  }
  .wrap{
    width: 120rem;
    display: block;
    margin:15rem auto;
    .shopping{
      height: 12rem;
      background: url('../../../assets/Yuncang1/Yuncang3.png') no-repeat center center;
      background-size: 100% 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      align-items: center;
      margin-bottom: 8rem;
      margin-top: -8rem;
      position: relative;
      &::after{
        content: '';
        position: absolute;
        width: 8rem;
        height: 5.3rem;
        background:url('../../../assets/Yuncang1/Yuncang2.png') no-repeat center center;
        background-size: 100% 100%;
        left: 1rem;
        top: -2rem;
      }
      .money{
        width: 48rem;
        text-align: center;
        font-size: 4rem;
        color: #fff;
        span{
          font-size: 6rem;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
        }
      }
      .cay{
        width: 58rem;
        display: flex;
        justify-content: center;
        div{
          width: 33%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          img{height: 3.6rem}
          span{margin-top:1rem }
        }
      }
    }
    h3{
      font-size: 2.8rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 2.8rem;
      margin-bottom: 3.2rem;
    }
    h4{
      font-size: 1.6rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      margin-bottom: 10.0rem;
      color: #444955;
      line-height: 4.0rem;
    }
    .programmeOne-box{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      text-align: center;
      margin: 6.0rem auto;
      div{
        width: 18.0rem;
        height: 26.0rem;
        margin-left: .5rem;
        margin-right: .5rem;
        background: #FFFEFF;
        box-shadow: 0rem .2rem .8rem 0rem rgba(0,0,0,0.2);
        border-radius: .4rem;
        margin-bottom: 4.0rem;
        font-size: 1.8rem;
        font-family: PingFangSC-Medium, PingFang SC;
        padding: 2.0rem;
        font-weight: 500;
        color: #333333;
        line-height: 2;

        img{
          width: 2.4rem;
          height: 2.4rem;
          margin-right: .5rem;
        }
        h5{
          margin: 0;
          line-height: 2.0rem;
        }
        span{
          display: flex;
          margin-bottom: 2.0rem;
        }
        em{
          font-style: normal;
          font-size: 1.6rem;
        }
      }
    }
  }
}
</style>
